/* Learn sub-nav: keep the active tab visible when the row scrolls
   on small screens. All JS lives in assets/ — never in .liquid files. */
(function () {
  var row = document.querySelector('.learn-subnav__row');
  if (!row) return;
  var active = row.querySelector('[aria-current="page"]');
  if (!active) return;
  var max = row.scrollWidth - row.clientWidth;
  if (max <= 0) return; /* nothing to scroll */
  /* Position of the tab measured inside the row (offsetLeft is unreliable
     here — the row is not the tab's offsetParent). */
  var tabLeft = active.getBoundingClientRect().left
              - row.getBoundingClientRect().left + row.scrollLeft;
  var target = tabLeft - (row.clientWidth - active.offsetWidth) / 2;
  if (target < 0) target = 0;
  if (target > max) target = max;
  row.scrollLeft = target; /* instant — runs before first interaction; no motion */
})();
